import _ from 'lodash';

// tagName accepts any HTML element tag as a string
// for example: 'p', 'div', 'input', 'span'

// attributes accept an object of HTML attributes
// { class: "my-class", for: "input", id: "my-id" }
// boolean attributes, like checked or required should be
// appended to the element after creation
// const newElm = createDomElement('input', {})
// newElm.checked = this.checked

const createDomElement = (tagName, attributes) => {
  const domElm = document.createElement(tagName);

  _.forEach(attributes, (value, attr) => {
    domElm.setAttribute(attr, value);
  });

  return domElm;
};

export default createDomElement;



// WEBPACK FOOTER //
// ./src/create-dom-element.js